
import {defineComponent} from 'vue';
import PasswordUtils from "@/utils/PasswordUtils";
import LoadingUtils from "@/utils/LoadingUtils";
import Dialog from "@/utils/Dialog";

export default defineComponent({
  name: 'PasswordReminderResetView',
  components: {},
  created() {
    let eParam = this.$route.query.e;
    if (!eParam) {
      eParam = '';
    }
    this.tParam = this.$route.query.t as string;
    if (!this.tParam) {
      this.tParam = '';
    }
    this.axios.get('/eDecode', { params: { e: eParam } }).then((res) => {
      this.loginId = res.data;
      if (this.loginId) {
        this.axios.post('/logInfo', {functionName: 'Webユーザーパスワード再設定', action: 'パスワード再設定画面表示', message: this.loginId}).then((res) => {
          //
        }).catch()
        this.axios.get('/isTimeout', { params: { t: this.tParam } }).then((timeoutRes) => {
          this.timeout = timeoutRes.data as boolean;
          this.ready = true;
        });
      } else {
        this.axios.post('/logError', {functionName: 'Webユーザーパスワード再設定', action: 'パスワード再設定画面表示', message: '複合化に失敗しました。'}).then((res) => {
          //
        }).catch()
        this.ready = true;
      }
    }).catch();
    this.axios.get('/getConfig', { params: { keys: [
          'keitai_kaisha_docomo',
          'keitai_kaisha_au',
          'keitai_kaisha_softbank',
          'keitai_kaisha_rakuten',
          'mail_domain',
          'pwset_url',
          'pwset_url_kigen',
          'kakunin_cd_kigen'] } }).then((configRes) => {
      this.configs = configRes.data as { [key: string]: string };
    });
  },
  methods:{
    sendResetPasswordMail(){
      LoadingUtils.start()
      this.axios.post('/sendResetPasswordMail', {mailAddress: this.mailAddress}).then((res)=>{
        //
      }).catch((e)=>{
        console.log(e)
      }).finally(()=>{
        LoadingUtils.end()
      })
    },
    async resetPassword() {
      this.timeout = (await this.axios.get('/isTimeout', {
        params: {
          t: this.tParam
        }
      })).data as boolean
      if (!this.timeout) {
        Dialog.confirm('パスワードをリセットよろしいですか？').then((ok: boolean)=>{
          if (ok) {
            LoadingUtils.start();
            setTimeout(() => {
              (this.$refs.resetPasswordButton as any).focus();
            }, 0)
            this.axios.post('/resetPassword', {loginId: this.loginId, password: this.password}).then((res) => {
              this.reseted = true
            }).catch((e) => {
              //
            }).finally(() => {
              LoadingUtils.end()
            })
          }
        })
      }
    }
  },
  data(){
    return {
      loginPath: process.env.VUE_APP_PUBLIC_PATH,
      title: 'パスワード再設定',
      configs: {} as { [key: string]: string },
      mailAddress: '' as string,
      ready: false,
      loginId: '',
      password: '' as string,
      confirmPassword: '',
      showMessage: false,
      showPassword: false,
      alreadyResetd: false,
      reseted: false,
      timeout: false,
      tParam : ''
    }
  },
  computed:{
    canReset(): boolean{
      return (this.validPassword) && (this.password === this.confirmPassword) && (!this.reseted)
    },
    validPassword():boolean{
      return PasswordUtils.validPassword(this.password)
    }
  }
});
